/* @flow */
import * as React from 'react';

type MaybeCleanUpFn = void | (() => void);

export default function useEffectOnce(create: () => MaybeCleanUpFn) {
    return React.useEffect(create, []);
}
